"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = base58Decode;

var _util = require("@polkadot/util");

var _bs = require("./bs58");

var _validate = _interopRequireDefault(require("./validate"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name base58Decode
 * @summary Decodes a base58 value.
 * @description
 * From the provided input, decode the base58 and return the result as an `Uint8Array`.
 */
function base58Decode(value, ipfsCompat = false) {
  if (ipfsCompat) {
    (0, _util.assert)(value[0] === 'z', "Expected IPFS base32 identifier 'z' at string start");
    value = value.substr(1);
  }

  (0, _validate.default)(value);
  return (0, _util.bufferToU8a)(_bs.bs58.decode(value));
}